// Default exchange rate (fallback)
const DEFAULT_USD_TO_PKR = 275;

// Dynamic rate storage - updated from API
let currentUsdToPkr = DEFAULT_USD_TO_PKR;

/**
 * Update the exchange rate used for conversions
 * Call this when you fetch a new rate from the API
 */
export const setExchangeRate = (usdToPkr: number): void => {
  currentUsdToPkr = usdToPkr;
};

/**
 * Get current PKR to USD conversion rate
 */
export const getPkrToUsdRate = (): number => 1 / currentUsdToPkr;

/**
 * Get current USD to PKR conversion rate
 */
export const getUsdToPkrRate = (): number => currentUsdToPkr;

/**
 * Format a number as PKR currency
 * @param amount - The amount to format
 * @returns Formatted currency string
 */
export const formatPKR = (amount: number): string => {
  return new Intl.NumberFormat('ur-PK', {
    style: 'currency',
    currency: 'PKR',
  }).format(amount);
};

/**
 * Format a number as USD currency (converted from PKR)
 * @param amount - The amount in PKR to convert and format
 * @returns Formatted currency string
 */
export const formatUSD = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount / currentUsdToPkr);
};

/**
 * Convert PKR amount to USD
 */
export const convertPkrToUsd = (pkrAmount: number): number => {
  return pkrAmount / currentUsdToPkr;
};

/**
 * Convert USD amount to PKR
 */
export const convertUsdToPkr = (usdAmount: number): number => {
  return usdAmount * currentUsdToPkr;
};

// Legacy export for backward compatibility
export const PKR_TO_USD = 1 / DEFAULT_USD_TO_PKR;

/**
 * Format a weight value in kilograms
 * @param weight - The weight to format
 * @returns Formatted weight string
 */
export const formatWeight = (weight: number): string => {
  return `${weight.toFixed(2)} kg`;
}; 